import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from "react-loader";
import { toast, ToastContainer } from "react-toastify";
import {
  Button,
  Col,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";

import Navbar from "../../../../components/CustomNav/CustomNav.Component";
import withServices from "../../../../HOCs/withServices";
import { Wrapper, Content, ContentRow } from "./SingleSchool.styles";
import {
  currentBaseUrl,
  currentProfile,
  getGeneralSmartTableData,
  isUserLoggedIn,
} from "../../../../common/services";

import { CSVLink } from "react-csv";

interface IProps {
  services?: any;
  location?: any;
  match?: any;
  history?: any;
}

interface IState {
  toLogin: boolean;
  loaded: boolean;
  data: any;
  selectedLesson: string;
  isNavigate: boolean;
  destination: string;
}

class SingleSchool extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      destination: "",
      toLogin: false,
      loaded: true,
      isNavigate: false,
      data: {},
      selectedLesson: "",
    };

    this.onLogout = this.onLogout.bind(this);
    this.onGoBack = this.onGoBack.bind(this);
    this.urnModalToggle = this.urnModalToggle.bind(this);
    this.urnSubmit = this.urnSubmit.bind(this);
    this.deptModalToggle = this.deptModalToggle.bind(this);
    this.deptSubmit = this.deptSubmit.bind(this);
    this.reportGenerate = this.reportGenerate.bind(this);
    this.viewMoreData = this.viewMoreData.bind(this);
  }

  public customTD = (props) => {
    return (
      <td>
        <Button
          /*tslint:disable-next-line jsx-no-lambda*/
          onClick={() => this.viewMoreData(props)}
          disabled={props.rowData.PreAssesmentDone === "no"}
        >
          View More
        </Button>
      </td>
    );
  };

  public onGoBack() {
    const dest = this.props.services.currentBaseUrl + "institutions";

    this.setState({
      isNavigate: true,
      destination: dest,
    });
  }

  public viewMoreData(props) {
    console.log(props.rowData.id);
    // navigate to more student data
    // this.setState({navigate: true, destination: this.state.baseurl + "datacenter"});
    // this.setState({navigate: true, destination: this.state.baseurl + "viewstudentdata/" + props.rowData.id});
    const history: any = this.props.history;
    history.push(`${currentBaseUrl()}viewstudentdata/${props.rowData.id}`);
  }

  public onLogout() {
    this.setState({ toLogin: true });
  }

  public async reportGenerate(row) {
    const userid = row.rowData.User__id;

    const {
      services: { isUserLoggedIn, adminAPI, currentUserID },
    } = this.props;

    const reportRes = await adminAPI.genReports(userid);

    if (reportRes.ok) {
      toast.success("Generating reports");
    }
  }

  public async componentDidMount() {
    const {
      match,
      history,
      location,
      services: { isUserLoggedIn, teachersAPI, currentUserID },
    } = this.props;

    if (!isUserLoggedIn) {
      this.setState({ toLogin: true });
    }

    const {
      params: { id: schoolID },
    } = match;

    const studentsDataKey = [
      "FullName",
      "User",
      "PreAssesmentDone",
      "ParentStudentCode",
      "field_1",
      "field_2",
      "field_3",
      "field_4",
      "field_5",
      "generate",
    ];

    const studentsThead = [
      "Name",
      "Username",
      "0.5 Done",
      "Code",
      currentProfile().Profiledata.field_config
        ? currentProfile().Profiledata.field_config.field_1
        : "Field-1",
      currentProfile().Profiledata.field_config
        ? currentProfile().Profiledata.field_config.field_2
        : "Field-2",
      currentProfile().Profiledata.field_config
        ? currentProfile().Profiledata.field_config.field_3
        : "Field-3",
      currentProfile().Profiledata.field_config
        ? currentProfile().Profiledata.field_config.field_4
        : "Field-4",
      currentProfile().Profiledata.field_config
        ? currentProfile().Profiledata.field_config.field_5
        : "Field-5",
      "Action",
    ];

    const membersRes = await teachersAPI.getSchoolStudents();

    if (membersRes.ok) {
      const students = membersRes.data.students;

      this.setState({
        data: {
          deptModal: false,
          students,
          loaded: true,
          schoolID,
          studentsDataKey,
          studentsThead,
          uploading: false,
          urnModal: false,
        },
      });
    } else {
      toast.error("Error fetching interaction details!");
    }
  }

  public urnModalToggle() {
    const data = this.state.data;

    data.urnModal = !data.urnModal;

    this.setState({ data });
  }

  public deptModalToggle() {
    const data = this.state.data;

    data.deptModal = !data.deptModal;

    this.setState({ data });
  }

  public async urnSubmit(e) {
    e.preventDefault();

    const data = this.state.data;

    data.uploading = true;

    this.setState({ data });

    const fileInputElement = e.target.elements.upld;
    const formData = new FormData();

    for (const row of fileInputElement.files) {
      formData.append("files", row);
    }

    const res = await this.props.services.adminAPI.updloadUrn(
      formData,
      data.schoolID
    );

    if (res.ok) {
      const studentsRes = await this.props.services.adminAPI.getSchoolMembers(
        data.schoolID
      );

      if (studentsRes.ok) {
        const students = studentsRes.data.users;

        const data = this.state.data;

        data.students = students;

        data.uploading = false;

        data.urnModal = false;

        this.setState({ data });

        toast.success("Success");
      }
    } else {
      toast.error("Failed to complete upload");
    }

    data.uploading = false;

    this.setState({ data });
  }

  public async deptSubmit(e) {
    e.preventDefault();

    const data = this.state.data;

    data.uploading = true;

    this.setState({ data });

    const fileInputElement = e.target.elements.upld;
    const formData = new FormData();

    for (const row of fileInputElement.files) {
      formData.append("files", row);
    }

    const res = await this.props.services.adminAPI.updloadDept(
      formData,
      data.schoolID
    );

    if (res.ok) {
      const studentsRes = await this.props.services.adminAPI.getSchoolMembers(
        data.schoolID
      );

      if (studentsRes.ok) {
        const students = studentsRes.data.users;

        const data = this.state.data;

        data.students = students;

        data.uploading = false;

        data.urnModal = false;

        this.setState({ data });

        toast.success("Success");
      }
    } else {
      toast.error("Failed to complete upload");
    }

    data.uploading = false;

    this.setState({ data });
  }

  public render() {
    const { data } = this.state;

    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }

    if (this.state.isNavigate) {
      return <Redirect to={this.state.destination} />;
    }

    if (Object.keys(data).length === 0) {
      return <Loader color="#acff24" />;
    }

    return (
      <Wrapper>
        <ToastContainer />
        <Navbar logoutParent={this.onLogout} />
        <Content>
          <ContentRow className="single-col">
            <p className="go-back" onClick={this.onGoBack}>
              &lt; Back
            </p>
          </ContentRow>
        </Content>

        <Content>
          <SortableTbl
            tblData={data.students}
            tHead={data.studentsThead}
            dKey={data.studentsDataKey}
            customTd={[
              { custd: this.customTD, keyItem: "generate", sortable: false },
            ]}
            defaultCSS={false}
          />
        </Content>

        <Content>
          <Modal
            isOpen={data.urnModal}
            toggle={this.urnModalToggle}
            style={{ marginTop: "10%" }}
          >
            <ModalHeader toggle={this.urnModalToggle}>
              {" "}
              Students Upload
            </ModalHeader>
            <ModalBody>
              <form onSubmit={this.urnSubmit}>
                <Row>
                  <Col xs="12">
                    <input
                      id="upld"
                      type="file"
                      name="upld"
                      accept=".csv"
                      multiple={false}
                      required={true}
                    />
                  </Col>

                  <Loader color="#3EE9F7" loaded={!data.uploading}>
                    <Button
                      color="primary"
                      type="submit"
                      className="adminmodalbutton"
                    >
                      Submit
                    </Button>
                    <Button
                      onClick={this.urnModalToggle}
                      className="adminmodalbutton"
                    >
                      Cancel
                    </Button>
                  </Loader>
                </Row>
              </form>
            </ModalBody>
          </Modal>
          <Modal
            isOpen={data.deptModal}
            toggle={this.deptModalToggle}
            style={{ marginTop: "10%" }}
          >
            <ModalHeader toggle={this.urnModalToggle}>
              {" "}
              Extra Data Upload
            </ModalHeader>
            <ModalBody>
              <form onSubmit={this.deptSubmit}>
                <Row>
                  <Col xs="12">
                    <input
                      id="upld"
                      type="file"
                      name="upld"
                      accept=".csv"
                      multiple={false}
                      required={true}
                    />
                  </Col>

                  <Loader color="#3EE9F7" loaded={!data.uploading}>
                    <Button
                      color="primary"
                      type="submit"
                      className="adminmodalbutton"
                    >
                      Submit
                    </Button>
                    <Button
                      onClick={this.urnModalToggle}
                      className="adminmodalbutton"
                    >
                      Cancel
                    </Button>
                  </Loader>
                </Row>
              </form>
            </ModalBody>
          </Modal>
        </Content>
      </Wrapper>
    );
  }
}

export default withServices(SingleSchool);



// WEBPACK FOOTER //
// ./src/pages/DataCenter/Teacher/SingleSchool/SingleSchool.tsx